import { Reveal } from "@/components/Reveal";

export default function TrustStatement() {
  const items = [
    { k: "We understand hospitality.", v: "Solutions built for real properties, not generic websites." },
    { k: "We understand how guests search.", v: "From discovery to booking, we optimize every touchpoint." },
    { k: "We understand booking platforms.", v: "Booking.com, Airbnb, Agoda, Expedia, Google & Tripadvisor." },
  ];
  return (
    <section className="border-b border-line bg-white py-16 lg:py-20" data-testid="trust-statement">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="font-serif text-2xl leading-snug text-navy sm:text-3xl">
            We help properties build a stronger online presence, optimize booking platforms and create better opportunities for business growth.
          </p>
        </Reveal>
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.1} className="border-l-2 border-sky pl-5">
              <p className="font-serif text-lg font-semibold text-navy">{it.k}</p>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{it.v}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
